import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {TmtErpPanelFilterService} from '../service/tmt-erp-panel-filter.service';
import {TmtErpFilterModalComponent} from '../components/tmt-erp-filter-modal/tmt-erp-filter-modal.component';

@Component({
  selector: 'app-tmt-erp-panel',
  templateUrl: './tmt-erp-panel.component.html',
  standalone: false,
})
export class TmtErpPanelComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(TmtErpPanelFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      this.openFilters();
    });
  }

  private openFilters(): void {
    const dialog = this.dialog.open(TmtErpFilterModalComponent, {width: '700px', panelClass: 'tmt-erp-filter-dialog'});
    dialog.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
  }
}
